import { useCallback } from "react";
import { ProductionFulfillmentApi, useAPIAction } from "melco-shared-logic";

export const useDeleteDataMappings = () => {
  const [deleteDataMapping] = useAPIAction(
    ProductionFulfillmentApi,
    async (api, id: string) => {
      const data = await api.productionFulfillmentMappingsDelete({ id });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "dataMappings.list.actions.delete",
    }
  );

  return useCallback(
    async (dataMappingIds: string[]) => {
      const successfullyDeleted: string[] = [];

      for (const dataMappingId of dataMappingIds) {
        try {
          await deleteDataMapping(dataMappingId);
          successfullyDeleted.push(dataMappingId);
        } catch (e) {
          // error handling is already done in useAPIAction
        }
      }

      return successfullyDeleted;
    },
    [deleteDataMapping]
  );
};
